// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__7pLQA","videoBox":"Cover_videoBox__1o8WL"};